module.exports = __webpack_public_path__ + "img/search1.d5ee657c.jpg";